import { DestroyRef, Directive, OnInit, inject, input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NgControl } from "@angular/forms";
import { BaseComponent } from "@app/shared/components/abstracts/base-component";
import { debounceTime } from "rxjs";

@Directive({
  selector: "[appFormFieldTrim]"
})
export class FormFieldTrimDirective extends BaseComponent implements OnInit {
  private control = inject(NgControl);
  debounce = input<number>();
  tab: undefined;

  private _destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.control?.valueChanges?.pipe(debounceTime(this.debounce() ?? this.getDebounce()), takeUntilDestroyed(this._destroyRef)).subscribe((val) => {
      if (this.control?.dirty) {
        this.control?.control.setValue(val?.toString().trim(), {
          emitEvent: false
        });
      }
    });
  }
}
